import React from 'react';
import Navbar from './../Components/Navbar'
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { MdLogout, MdFilterAlt, MdAddCircle, MdBarChart, MdCalendarMonth, MdNfc, MdCall, MdFolderShared, MdSchedule } from 'react-icons/md';
import { ListItemButton } from '@mui/material';

import Form from './../Components/Form';
import Report from '../Components/Reports';
import Filter from './../Components/Filter';
import CreateAccount from './../Components/CreateAcc';
import UnscheduledPatients from './../Components/Unscheduled';
import Summary from './../Components/Summary';
import CalendarComp from './../Components/Calendar';
import SchedTwo from '../Components/SchedTwo';

const drawerWidth = 250;

class AdminDashboard extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            isLoading: false,
            form: false,
            filter: false,
            report: false,
            create_acc: false,
            unscheduled: false,
            summary: true,
            calendar: false,
            schedTwo: false
        }
    }

    logout = () => {
        localStorage.clear();
        window.location.href = "/"
    }

    render(){
        return (
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                    <Navbar />
                </AppBar>

                <Drawer
                    variant="permanent"
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                    }}>
                    <Toolbar />
                    <Box sx={{ overflow: 'auto' }}>
                        <List color="primary">
                            {["Dashboard", "Calendar", "Form", "Filter", "Reports", "Create Account", "Unscheduled Patients", "Two Week - Sched"].map((t, index) => (
                                <ListItemButton
                                    key={t}
                                    onClick={() => {
                                        // if (t === "Patient Form") {
                                        //     this.setState({ form: true, filter: false, report: false, create_acc: false })
                                        // }else 
                                        if (t === "Dashboard") {
                                            this.setState({ form: false, filter: false, report: false, create_acc: false, unscheduled: false, summary: true, calendar: false, schedTwo: false})
                                        } else if (t === "Calendar") {
                                            this.setState({ form: false, filter: false, report: false, create_acc: false, unscheduled: false, summary: false, calendar: true, schedTwo: false})
                                        }else if (t === "Form") {
                                            this.setState({ form: true, filter: false, report: false, create_acc: false, unscheduled: false, summary: false, calendar: false, schedTwo: false})
                                        }else if (t === "Filter") {
                                            this.setState({ form: false, filter: true, report: false, create_acc: false, unscheduled: false, summary: false, calendar: false, schedTwo: false})
                                        }else if (t === "Reports") {
                                            this.setState({ form: false, filter: false, report: true, create_acc: false, unscheduled: false, summary: false, calendar: false, schedTwo: false})
                                        }else if (t === "Create Account") {
                                            this.setState({ form: false, filter: false, report: false, create_acc: true, unscheduled: false, summary: false, calendar: false, schedTwo: false})
                                        }else if (t === "Unscheduled Patients") {
                                            this.setState({ form: false, filter: false, report: false, create_acc: false, unscheduled: true, summary: false, calendar: false, schedTwo: false})
                                        }else if (t === "Two Week - Sched") {
                                            this.setState({ form: false, filter: false, report: false, create_acc: false, unscheduled: false, summary: false, calendar: false, schedTwo: true})
                                        }
                                    }}>
                                    <ListItemIcon sx={{ color: "#9333ea", fontSize: "25px" }}>
                                        {index === 0 && <MdNfc/>}
                                        {/* {index === 1 && <MdAddCircle />} */}
                                        {index === 2 && <MdAddCircle />}
                                        {index === 3 && <MdFilterAlt />}
                                        {index === 4 && <MdBarChart/>}
                                        {index === 5 && <MdAddCircle />}
                                        {index === 1 && <MdCalendarMonth/>}
                                        {index === 6 && <MdCall/>}
                                        {index === 7 && <MdSchedule />}
                                    </ListItemIcon>
                                    <ListItemText primary={t} sx={{ color: "black" }} />
                                </ListItemButton>
                            ))}
                        </List>
                        <Divider />
                        <List>
                            {['Logout'].map((text, index) => (
                                <ListItem key={text} button onClick={this.logout}>

                                    <ListItemIcon sx={{ color: "#dc2626", fontSize: "25px" }}>
                                        {index === 0 && <MdLogout />}
                                    </ListItemIcon>
                                    <ListItemText primary={text} sx={{ color: "black" }} />

                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </Drawer>
                <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                    <Toolbar />
                    {this.state.form && (<Form />)}
                    {this.state.calendar && (<CalendarComp />)}
                    {this.state.summary && <Summary />}
                    {this.state.filter && (<Filter />)}
                    {this.state.report && (<Report />)}
                    {this.state.create_acc && (<CreateAccount />)}
                    {this.state.unscheduled && (<UnscheduledPatients />)}
                    {this.state.schedTwo && (<SchedTwo />)}
                </Box>  
            </Box>
        )
    }
}

export default AdminDashboard